import React, {Component} from "react";
import analytics_logo from '../../images/ga4_logo.png';

export class AnalyticsLogo extends Component {
    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getImage() {
        return analytics_logo;
    }

    render() {
        return <img alt="GA4" style={this.props.styles} src={this.getImage()} height={this.getHeight()} width={this.getWidth()} hspace={this.getHSpace()} vspace={this.getVSpace()}/>
    }
}
